module.exports = __webpack_public_path__ + "static/img/3.7448072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/3.png
// module id = 5in5
// module chunks = 0